module.exports = __webpack_public_path__ + "img/6@2x.07c4ef68.png";